var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TheLayout',[_c('CardProfile'),_c('CardUser'),_c('CardScores'),_c('CardRecent')],1)}
var staticRenderFns = []

export { render, staticRenderFns }